import { useEffect, useRef, useState } from "react";
import { Add_cart, ListSVG, Sub_cart } from "../../../../assets/icons";
import useAppAccessor from "../../../../hooks/useappAccessor";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { getBrandTheme } from "../../../../utils/brand.util";
import { addCurrencyFormat } from "../../../../utils/currency.util";
import { setProductsInCart } from "../../interaction.actions";
import CartListView from "../interactionShoppingCart/components/cartListView";
import CartSVG from "../interactionShoppingCart/components/cartSVG";
import { isMobile, openNewTab } from "../../../../utils/utils";

const decimalComponent = (number: any) => {
  if (number === undefined) return;
  if (
    typeof number === "string" &&
    !number.includes(".") &&
    !number.includes("-") &&
    !number.includes(",")
  ) {
    number = addCurrencyFormat(number)
  }

  if (number.includes("-")) {
    const numb1: any = number.toString().split("-")[0];
    const numb2: any = number.toString().split("-")[1];
    const [integerPart, decimalPart] = numb1.toString().includes(".")
      ? numb1.toString().split(".")
      : [numb1.toString(), "00"];
    const [integerPart_2, decimalPart_2] = numb2.toString().includes(".")
      ? numb2.toString().split(".")
      : [numb2.toString(), "00"];

    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart}`}</span>
        </div>
        -
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15, marginLeft: 5 }}
        >
          {`${integerPart_2}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_2}`}</span>
        </div>
      </div>
    );
  } else if (number.includes(",")) {
    const [integerPart_3, decimalPart_3] = number.toString().includes(",")
      ? number.toString().split(",")
      : [number.toString(), "00"];
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart_3},`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_3}`}</span>
        </div>
      </div>
    );
  } else {
    var [integerPart_3, decimalPart_3] = number.toString().includes(".")
      ? number.toString().split(".")
      : [number.toString(), "00"];
    if (decimalPart_3?.includes(" ")) {
      decimalPart_3 = decimalPart_3.split(" ")[0];
    }
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart_3}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_3}`}</span>
        </div>
      </div>
    );
  }
};

const InteractionShoppingCartPartnerCo = (props: any) => {
  const [qtyNumber, setQtyNumber] = useState(1);
  const [totalNum, setTotalNum] = useState(1);
  const [isShowCart, setIsShowCart] = useState(props.showCart ?? false);
  const [images, setImages] = useState<any>([]);
  const [mainImage, setMainImage] = useState<any>("");
  const [currentOption, setCurrentOption] = useState<any>(null);
  const { getInteractions, getUserData, getLiveMainData } = useAppAccessor();
  const { joinWithAttendeeData } = getLiveMainData();
  const { client, referrer_user } = getUserData();
  const { productDetail, productsInCart } = getInteractions();
  const [displayShortDes, setDisplayShortDes] = useState(false);
  const dispatch = useAppDispatch();
  const [showSelection, setShowSelection] = useState(false);
  const [added, setAdded] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const [maskHeight, setMaskHeight] = useState(
    document.getElementById("idVideoRoomContainer")?.offsetHeight ?? 2500
  );

  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const iFrameContainer = document.getElementById("iFrameContainer");
    if (iFrameContainer) {
      iFrameContainer.scrollTop = 0;
    }
  }, [isShowCart]);

  const handleAddToCartClick = () => {
    if (!isSelectionComplete()) return;

    setShowSelection(true);

    if (productDetail?.options && productDetail?.options.length > 0) {
      addToCart();
    } else {
      addToCart();
    }

    setTimeout(() => {
      setShowSelection(false);
    }, 5000);
  };

  useEffect(() => {
    var total = 0;
    productsInCart.forEach((item: any) => {
      total += item.quantity;
    });
    setTotalNum(total);
  }, [productsInCart]);

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.offsetHeight;
      if (document.getElementById("idVideoRoomContainer")?.offsetHeight) {
        if (
          document.getElementById("idVideoRoomContainer")!.offsetHeight >=
          height
        ) {
          setMaskHeight(
            document.getElementById("idVideoRoomContainer")!.offsetHeight + 200
          );
        }
      }
    }
  }, [displayShortDes]);

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.offsetHeight;
      if (document.getElementById("idVideoRoomContainer")?.offsetHeight) {
        if (
          document.getElementById("idVideoRoomContainer")!.offsetHeight >=
          height
        ) {
          setMaskHeight(
            document.getElementById("idVideoRoomContainer")!.offsetHeight + 200
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    if (!productDetail) return;

    setMainImage(productDetail.imageUrl || "");

    if (productDetail.options && productDetail.options.length === 1) {
      const option = productDetail.options[0];
      setCurrentOption(option);

      let imagesArr: any[] = [];
      if (productDetail.imageUrl) {
        imagesArr.push(productDetail.imageUrl);
      }
      
      if (option && option.images && option.images.length > 0) {
        option.images.forEach((item: any) => {
          if (item?.sizes && item.sizes[0]?.url) {
            imagesArr.push(item.sizes[0].url);
          }
        });
      }
      
      setMainImage(imagesArr[0] || productDetail.imageUrl || "");
      setImages(imagesArr.length > 0 ? imagesArr : []);
      
      if (productsInCart.find((item: any) => item.sku === option.sku)) {
        setAdded(true);
      } else {
        setAdded(false);
      }
    } else {
      setImages(productDetail.imageUrl ? [productDetail.imageUrl] : []);
      setCurrentOption(null);
    }
  }, [productDetail, productsInCart]);

  useEffect(() => {
    if (productDetail?.fromCarsoul) {
      setIsShowCart(false);
    }
  }, [productDetail]);

  useEffect(() => {
    if (productDetail?.id) {
      setIsShowCart(false);
    }
  }, [productDetail?.id]);

  useEffect(() => {
    if (props.showCart !== undefined) {
      setIsShowCart(props.showCart);
    }
  }, [props.showCart]);

  useEffect(() => {
    if (!currentOption || !productDetail) return;
    
    if (productDetail.options && productDetail.options.length === 1) {
      return;
    }

    let imagesArr: any[] = [];
    
    if (productDetail.imageUrl) {
      imagesArr.push(productDetail.imageUrl);
    }
    
    if (currentOption.images && currentOption.images.length > 0) {
      currentOption.images.forEach((item: any) => {
        if (item?.sizes && item.sizes[0]?.url) {
          imagesArr.push(item.sizes[0].url);
        }
      });

      const extractIdentifier = (url: string) => {
        const match = url.match(/([a-fA-F0-9]{10})(?=\.jpg)/);
        return match ? match[1] : null;
      };

      const uniqueIdentifiers = new Set();
      const uniqueImagesArr = imagesArr.filter((url) => {
        const identifier = extractIdentifier(url);
        if (identifier && !uniqueIdentifiers.has(identifier)) {
          uniqueIdentifiers.add(identifier);
          return true;
        }
        if (!identifier) {
          return true;
        }
        return false;
      });

      setMainImage(uniqueImagesArr[0] || productDetail.imageUrl || "");
      setImages(uniqueImagesArr);
    } else {
      setMainImage(productDetail.imageUrl || "");
      setImages(productDetail.imageUrl ? [productDetail.imageUrl] : []);
    }
  }, [currentOption, productDetail]);

  const addToCart = () => {
    let cartProducts = productsInCart;
    const existingProduct = cartProducts.find((item: any) => item.sku === currentOption?.sku);
    //TODO: Remove hard-coded number when client updating their maxQty in their product json.
    const maxQty = 100;
    
    if (existingProduct) {
      let newQuantity = existingProduct.quantity + qtyNumber;
      
      if (newQuantity > maxQty) {
        newQuantity = maxQty;
      }
      
      cartProducts = cartProducts.map((item: any) => {
        if (item.sku === currentOption?.sku) {
          return {
            ...item,
            quantity: newQuantity,
          };
        }
        return item;
      });
    } else {
      let finalQuantity = qtyNumber;
      if (finalQuantity > maxQty) {
        finalQuantity = maxQty;
      }
      
      setAdded(false);
      const productName = productDetail?.name !== currentOption?.name 
        ? `${productDetail?.name} (${currentOption?.name})`
        : productDetail?.shortDescription && 
          productDetail.shortDescription.trim() !== "" && 
          productDetail.shortDescription.trim() !== "<p></p>" &&
          productDetail.shortDescription.trim() !== "<p><br></p>"
          ? `${productDetail?.name} (${productDetail?.shortDescription})`
          : productDetail?.name;
      
      let product = {
        id: productDetail?.id,
        name: productName,
        price: currentOption?.price,
        priceString: currentOption?.priceString,
        sku: currentOption?.sku,
        quantity: finalQuantity,
        imageUrl: productDetail?.imageUrl,
        options: currentOption,
        locale: productDetail?.locale,
        maxQty: productDetail?.maxQty,
      };
      cartProducts.push(product);
    }

    setTimeout(() => {
      var total = 0;
      productsInCart.forEach((item: any) => {
        total += item.quantity;
      });
      setTotalNum(total);
    }, 1000);
    dispatch(setProductsInCart(cartProducts));
  };

  const handleQtyOnclick = (isIncrease: boolean) => {
    if (isIncrease) {
      if (qtyNumber < 100) {
        setQtyNumber(qtyNumber + 1);
      }
    } else {
      if (qtyNumber > 1) {
        setQtyNumber(qtyNumber - 1);
      }
    }
  };

  const isSelectionComplete = () => {
    if (productDetail?.options && productDetail?.options.length > 1) {
      return currentOption !== null;
    }
    return true;
  };

  const getOptionFontSize = (text?: string) => {
    const len = (text || "").trim().length;
    // NOTE: Styling <option> is inconsistent across browsers/OS.
    // We instead style the <select> so the selected value displays better.
    return len > 20 ? "12px" : "14px";
  };

  const doCheckOut = () => {
    let products: Array<any> = [];
    productsInCart.forEach((item: any) => {
      let options: Array<any> = [];
      options.push({ sku: item.options.sku });
      products.push({
        id: item.id.toString(),
        quantity: item.quantity,
        locale: item.locale,
        type: "PROD",
        userOptions: {
          appSourceId: "hussle",
        },
        options: options,
      });
    });

    const baseUrl = products[0]?.locale 
      ? `https://www.partner.co/${products[0].locale.replace(/_/g, '-').toLowerCase()}/add_to_cart`
      : "https://www.partner.co/en-us/add_to_cart";

    const productStrings = `?productid=${products[0].options[0].sku}&product_quantity=${qtyNumber}`

    let shareCode = "";

    if (referrer_user != null && referrer_user?.third_party_username) {
      shareCode = referrer_user!.third_party_username;
    } else if (
      joinWithAttendeeData != null &&
      joinWithAttendeeData!.issuer_metadata != null &&
      joinWithAttendeeData?.issuer_metadata?.third_party_username
    ) {
      shareCode = joinWithAttendeeData?.issuer_metadata?.third_party_username;
    }

    const checkoutUrl = `${baseUrl}${productStrings}&subscription=F&custid=${shareCode}&redirect_url=/checkout`;

    openNewTab(checkoutUrl);
  };

  const checkOutSingleItem = () => {
    if(!currentOption) return;

    const locale = productDetail?.locale || "en-us";
    const baseUrl = `https://www.partner.co/${locale.replace(/_/g, '-').toLowerCase()}/add_to_cart`;
    const productStrings = `?productid=${currentOption?.sku}&product_quantity=${qtyNumber}`

    let shareCode = "";
    if (referrer_user != null && referrer_user?.third_party_username) {
      shareCode = referrer_user!.third_party_username;
    } else if (
      joinWithAttendeeData != null &&
      joinWithAttendeeData!.issuer_metadata != null &&
      joinWithAttendeeData?.issuer_metadata?.third_party_username
    ) {
      shareCode = joinWithAttendeeData?.issuer_metadata?.third_party_username;
    }

    const checkoutUrl = `${baseUrl}${productStrings}&subscription=F&custid=${shareCode}&redirect_url=/checkout`;
    openNewTab(checkoutUrl);
  }
  
  const openNewTab = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const { language } = getUserData();

  const productDetailComponent = () => {
    const hasDescription = productDetail?.shortDescription && 
      productDetail.shortDescription.trim() !== "" && 
      productDetail.shortDescription.trim() !== "<p></p>" &&
      productDetail.shortDescription.trim() !== "<p><br></p>";
    
    const displayImage = mainImage || productDetail?.imageUrl;

    return (
      !isShowCart && (
        <div
          className="h-full w-full bg-white rounded-tr-2xl rounded-br-2xl"
          style={{ position: "relative" }}
        >
          <div
            className="h-16 w-full flex justify-between items-center bg-white border-b border-gray-200 shadow-sm border-radius-tr-2xl border-radius-br-2xl"
            style={
              isMobile
                ? {
                    width: "100%",
                    position: "fixed",
                    zIndex: 100,
                    marginTop: "0px",
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                  }
                : {
                    width: "calc(70% / 3 - 25px)",
                    position: "fixed",
                    zIndex: 100,
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                  }
            }
          >
            <button
              onClick={() => props.toggleProductList(false)}
              className="ml-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 group"
              aria-label="Go back"
            >
              <svg
                className="w-6 h-6 text-gray-700 group-hover:text-gray-900 transition-colors"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
            <div className="flex-grow text-center">
              <h1 className="text-lg font-semibold text-gray-900 tracking-tight">
                {language["shop_label"]}
              </h1>
            </div>
            <button
              className="mr-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 relative group"
              onClick={() => {
                setIsShowCart(true);
              }}
              aria-label="View cart"
            >
              {/* <div className="group-hover:opacity-80 transition-opacity"> */}
                {/* <CartSVG
                  width="22px"
                  stroke={getBrandTheme(client).primary}
                ></CartSVG>
              </div> */}
              {totalNum > 0 && (
                <div
                  className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1.5 flex items-center justify-center bg-gradient-to-r from-red-500 to-red-600 text-white text-xs font-bold rounded-full shadow-lg border-2 border-white"
                  style={{
                    boxShadow: "0 2px 8px rgba(239, 68, 68, 0.4)",
                  }}
                >
                  {totalNum > 99 ? "99+" : totalNum}
                </div>
              )}
            </button>
          </div>
          {showSelection && (
            <div
              ref={elementRef}
              style={
                isMobile
                  ? {
                      zIndex: 10009,
                      background: "white",
                      borderRadius: "5px",
                      position: "fixed",
                      top: "120px",
                      left: "10px",
                      height: "70px",
                      width: "calc(100% - 20px)",
                    }
                  : {
                      zIndex: 10009,
                      background: "white",
                      borderRadius: "5px",
                      position: "fixed",
                      top: "120px",
                      marginLeft: "20px",
                      height: "70px",
                      width: "calc(23% - 40px)",
                    }
              }
              onClick={() => setShowSelection(false)}
            >
              <div className="flex items-center justify-center">
                <img
                  src={productDetail?.imageUrl}
                  alt=""
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    borderRadius: "5px",
                  }}
                ></img>
                <div
                  style={{
                    width: "calc(100% - 80px)",
                    marginLeft: "50px",
                    marginTop: "15px",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    dangerouslySetInnerHTML={{ __html: productDetail?.name }}
                  />
                  <p
                    style={{
                      color: getBrandTheme(client).primary,
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {language["added_to_cart"]}
                  </p>
                </div>
              </div>
            </div>
          )}
          {showSelection && (
            <div
              onClick={() => {
                setShowSelection(false);
              }}
              className="w-full"
              style={
                isMobile
                  ? {
                      zIndex: 10008,
                      height: maskHeight + "px",
                      background: "black",
                      opacity: 0.25,
                      position: "fixed",
                      overflowY: "hidden",
                      top: "-15px",
                    }
                  : {
                      zIndex: 10008,
                      height: maskHeight + "px",
                      background: "black",
                      opacity: 0.25,
                      position: "absolute",
                      overflowY: "hidden",
                    }
              }
            ></div>
          )}
          <div style={{ height: "64px" }}></div>
          {displayImage && (
            <div 
              className={`w-full flex items-center justify-center ${isMobile ? "h-[200px] px-4" : "h-[147px]"}`}
            >
              <img 
                src={displayImage} 
                className={isMobile ? "h-full w-auto object-contain" : "h-full"} 
                alt={productDetail?.name || "Product"}
              />
            </div>
          )}
          <div
            id={"content"}
            className={`font-medium bg-white ${hasDescription ? "mt-2" : "mt-4"} ${isMobile ? "px-4" : "pl-7 pr-7"}`}
            style={{ 
              position: "relative",
              paddingBottom: isMobile && hasDescription ? "120px" : "0px"
            }}
          >
            <div className={`bg-white rounded-tr-2xl rounded-br-2xl shadow-sm border border-gray-100 ${isMobile ? "p-4 -mx-4" : "p-6 -mx-6"}`}>
              <div className={isMobile ? "mb-4" : "mb-6"}>
                <h1 className={`font-semibold text-gray-900 leading-tight ${isMobile ? "text-lg" : "text-2xl"}`}>
                  <div dangerouslySetInnerHTML={{ __html: productDetail?.name }} />
                </h1>
              </div>
              <div className={`flex ${isMobile ? "flex-col gap-3" : "justify-between items-center"}`}>
                <div className={`px-4 py-2 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200 shadow-sm ${isMobile ? "w-full" : ""}`}>
                  <span className={`font-bold text-gray-800 ${isMobile ? "text-lg" : "text-xl"}`}>
                    {currentOption !== null
                      ? decimalComponent(
                          addCurrencyFormat(currentOption?.priceString)
                        )
                      : productDetail?.minimumPriceString &&
                        productDetail?.maximumPriceString
                      ? decimalComponent(
                          productDetail?.minimumPriceString +
                            "-" +
                            productDetail?.maximumPriceString
                        )
                      : productDetail?.minimumPriceString
                      ? decimalComponent(productDetail?.minimumPriceString)
                      : productDetail?.maximumPriceString
                      ? decimalComponent(productDetail?.maximumPriceString)
                      : null}
                  </span>
                </div>
                <div className={`flex items-center bg-white border-2 border-gray-200 rounded-xl shadow-sm overflow-hidden ${isMobile ? "w-full" : ""}`} style={{ height: 42 }}>
                  <button
                    onClick={() => handleQtyOnclick(false)}
                    className={`h-full flex items-center justify-center bg-gray-50 hover:bg-gray-100 active:bg-gray-200 transition-colors duration-150 border-r border-gray-200 ${isMobile ? "w-1/4" : "w-12"}`}
                  >
                    <img
                      src={Sub_cart}
                      className="cursor-pointer"
                      onClick={() => handleQtyOnclick(false)}
                      alt="Decrease"
                    ></img>
                  </button>
                  <div className="w-2/4 h-full flex items-center justify-center bg-white font-semibold text-gray-800 text-base">
                    {qtyNumber}
                  </div>
                  <button
                    onClick={() => handleQtyOnclick(true)}
                    className={`h-full flex items-center justify-center bg-gray-50 hover:bg-gray-100 active:bg-gray-200 transition-colors duration-150 border-l border-gray-200 ${isMobile ? "w-1/4" : "w-12"}`}
                  >
                    <img
                      src={Add_cart}
                      className="cursor-pointer"
                      onClick={() => handleQtyOnclick(true)}
                      alt="Increase"
                    ></img>
                  </button>
                </div>
              </div>
              {productDetail?.options && productDetail?.options.length >= 1 &&
                productDetail?.selections?.map((selection: any) => (
                  <div key={selection.id} className={`mt-4 ${isMobile ? "mt-4" : "mt-5"}`}>
                    {selection.name && (
                      <label 
                        className={`block font-semibold text-gray-700 mb-2 ${isMobile ? "text-sm" : "text-base"}`}
                      >
                        {selection.name}
                      </label>
                    )}
                    <div className="relative">
                      <select
                        value={currentOption?.sku || ""}
                        onChange={(e: any) => {
                          const selectedOption = productDetail?.options.find(
                            (item: any) => item.sku === e.target.value
                          );
                          setCurrentOption(selectedOption);

                          if (productDetail?.options.length > 0) {
                            let cartProducts = productsInCart;
                            if (
                              cartProducts.find(
                                (item: any) => item.sku === e.target.value
                              )
                            ) {
                              setAdded(true);
                            } else {
                              setAdded(false);
                            }
                          }
                        }}
                        className={`
                          appearance-none bg-white text-gray-900 block w-full 
                          ${isMobile ? "py-4 px-4 text-base" : "py-3 px-4 text-base"} 
                          rounded-xl focus:ring-2 transition-all duration-200
                          ${currentOption ? "border-gray-300" : "border-gray-200"}
                          ${isMobile ? "min-h-[48px]" : ""}
                          hover:border-gray-300 border-2 border-gray-200
                        `}
                        style={{
                          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
                          backgroundPosition: "right 0.75rem center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "1.25em 1.25em",
                          paddingRight: isMobile ? "3rem" : "2.5rem",
                          fontSize: getOptionFontSize(currentOption?.name || ""),
                          lineHeight: "1.2",
                        }}
                      >
                        <option value="" disabled>
                          {language["please_select"]} {selection.name || "Option"}
                        </option>
                        {productDetail?.options?.map((item: any) => (
                          <option
                            key={item.sku}
                            disabled={item?.canBeAddedToCart === false}
                            value={item?.sku}
                          >
                            {item?.name + (item?.priceString ? ` (${item?.priceString})` : "")}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ))}

{hasDescription && (
              <>
                <div className={isMobile ? "mb-3" : "mb-4"}>
                  <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
                </div>
                <div className={isMobile ? "mt-1" : "mt-2"}>
                  <div 
                    className={`w-full font-medium text-black overflow-auto ${isMobile ? "text-xs mt-2" : "text-sm mt-4"}`} 
                    style={{ 
                      maxHeight: isMobile ? "300px" : "400px",
                      paddingBottom: isMobile ? "100px" : "0px"
                    }}
                  >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: productDetail?.shortDescription || "",
                    }}
                  />
                  {displayShortDes &&
                    productDetail?.shortDescription &&
                    productDetail?.shortDescription.endsWith("...") && (
                      <p
                        style={{
                          color: getBrandTheme(client).primary,
                          fontSize: isMobile ? "12px" : "14px",
                          cursor: "pointer",
                          marginTop: "8px",
                        }}
                        onClick={() => setDisplayShortDes(false)}
                      >
                        {language["see_details"]}
                      </p>
                    )}
                  </div>
                </div>
              </>
            )}
            </div>
          </div>

          {isMobile && (
            <div className={`w-full flex items-center justify-center bg-white ${hasDescription ? "pt-2 pb-4" : "pt-4 pb-6"}`}>
              <button
                className={`${isMobile ? "px-8 py-4 text-base" : "pl-6 pr-6 pt-3 pb-3 text-sm"} rounded-full text-white font-semibold transition-all duration-200 ${hasDescription ? "" : "shadow-lg"}`}
                style={
                  isSelectionComplete()
                    ? {
                        backgroundColor: getBrandTheme(client).primary,
                        opacity: 1,
                        position: "fixed",
                        bottom: "20px",
                        width: isMobile ? "calc(100% - 32px)" : "150px",
                        left: isMobile ? "16px" : "calc(50% - 75px)",
                        right: isMobile ? "16px" : "auto",
                        zIndex: 1000,
                        maxWidth: isMobile ? "none" : "150px",
                      }
                    : {
                        backgroundColor: getBrandTheme(client).primary,
                        opacity: 0.5,
                        position: "fixed",
                        bottom: "20px",
                        width: isMobile ? "calc(100% - 32px)" : "150px",
                        left: isMobile ? "16px" : "calc(50% - 75px)",
                        right: isMobile ? "16px" : "auto",
                        zIndex: 1000,
                        maxWidth: isMobile ? "none" : "150px",
                      }
                }
                onClick={() => {
                  if (isSelectionComplete()) checkOutSingleItem();
                }}
              >

                Checkout
              </button>
            </div>
          )}
          {!isMobile && hasDescription && <div style={{ paddingBottom: "80px" }}></div>}

          {!isMobile && (
            <div
              className={`w-full flex items-center justify-center bg-white ${hasDescription ? "pt-2 pb-2" : "pt-4 pb-4"}`}
              style={hasDescription ? {
                position: "fixed",
                bottom: "60px",
                width: isMobile ? "calc(100%)" : "calc(22.5% - 15px)",
                left: isMobile ? "50%" : "auto",
                right: "calc(5% + 10px)",
                transform: isMobile ? "translateX(-50%)" : "none",
                zIndex: 10,
              } : {
                position: "relative",
                width: "100%",
                zIndex: 10,
                marginTop: "16px",
              }}
            >
              <button
                className={`pl-6 pr-6 pt-3 pb-3 rounded-full text-white text-sm font-semibold transition-all duration-200 ${hasDescription ? "" : "shadow-lg hover:shadow-xl"}`}
                style={
                  isSelectionComplete()
                    ? {
                        backgroundColor: getBrandTheme(client).primary,
                        opacity: 1,
                        minWidth: "160px",
                        transform: hasDescription ? "none" : "scale(1)",
                      }
                    : {
                        backgroundColor: getBrandTheme(client).primary,
                        opacity: 0.5,
                        minWidth: "160px",
                        transform: hasDescription ? "none" : "scale(1)",
                      }
                }
                onClick={() => {
                  if (isSelectionComplete()) checkOutSingleItem();
                }}
              >
                Checkout
              </button>
            </div>
          )}
        </div>
      )
    );
  };

  const cartListViewComponent = () => {
    return (
      isShowCart && (
        <div className="h-full w-full bg-white">
          <div
            className="h-16 w-full flex justify-between items-center bg-white border-b border-gray-200 shadow-sm"
            style={
              isMobile
                ? {
                    width: "100%",
                    position: "fixed",
                    zIndex: 100,
                    marginTop: "0px",
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                  }
                : {
                    width: "calc(70% / 3 - 25px)",
                    position: "fixed",
                    zIndex: 100,
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                  }
            }
          >
            <button
              onClick={() => {
                props.toggleProductList(false);
                setIsShowCart(false);
              }}
              className="ml-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 group"
              aria-label="Go back"
            >
              <img
                src={ListSVG}
                color="black"
                alt="Icon"
                height={24}
                width={24}
                className="cursor-pointer opacity-70 group-hover:opacity-100 transition-opacity"
              />
            </button>
            <div className="flex-grow text-center">
              <h1 className="text-lg font-semibold text-gray-900 tracking-tight">
                {language["cart_label"]}
              </h1>
            </div>
            <div style={{ width: "40px" }} className="mr-4"></div>
          </div>
          <div style={{ height: "64px" }}></div>
          <CartListView
            productsInCart={productsInCart}
            setProductsInCart={(products: any) => {
              dispatch(setProductsInCart(products));
            }}
            setTotalNum={setTotalNum}
          />
          {productsInCart.length > 0 && (
            <div
                     className={`${isMobile ? "px-4 py-2 text-base" : "pl-6 pr-6 pt-3 pb-3 text-sm"} rounded-full text-white font-semibold transition-all duration-200`}
            >
              <button
                className={`w-full ${isMobile ? "py-4 text-base" : "py-3 text-sm"} rounded-lg text-white font-semibold transition-all duration-200 hover:opacity-90`}
                style={{ backgroundColor: getBrandTheme(client).primary }}
                onClick={doCheckOut}
              >
                {"Checkout (" + totalNum + " items)"}
              </button>
            </div>
          )}
        </div>
      )
    );
  };

  return (
    <div className="h-full w-full">
      {productDetailComponent()}
      {cartListViewComponent()}
    </div>
  );
};

export default InteractionShoppingCartPartnerCo;


